import { Server } from "miragejs";
import modules from "./api/modules";

new Server({
    routes() {
        this.urlPrefix = process.env.VUE_APP_BASE_API_URL

        // system
        this.get("/system-modules", () => modules)

        // jobs
        this.get("/schema/envelopes", () => {
            return {
                "bulkActions": null,
                "customFilterFields": null,
                "tableFields":[
                    {
                        "name": "subject",
                        "title": "Subject",
                        "sortField": "subject",
                        "filterable": true,
                        "searchable": true,
                        "width": "65%"
                    },
                    {
                        "name": "status",
                        "title": "Status",
                        "sortField": "status",
                        "filterable": false,
                        "searchable": false
                    }
                ]
            }

        })

        this.passthrough();
    }
})
